import {
  Metrics,
  Project,
  SovItem,
  StatusOption,
} from "../types/inspector.types";
import SovItemSection from "./SovItemSection";

interface FiTabProps {
  project: Project;
  metrics: Metrics;
  sovItems: SovItem[];
  notDrawnItems: [string, string, string][];
  collapsed: Record<string, boolean>;
  statusOptions: StatusOption[];
  drawAmount: string;
  drawPercentage: string;
  onToggleSov: (id: string) => void;
  onSetStatus: (id: string, status: number) => void;
  onSetCustomPct: (id: string, value: string) => void;
  onClearCustomPct: (id: string) => void;
  onToggleFlag: (id: string) => void;
  onFlagWithComment: (id: string, text: string) => void;
  onAddComment: (id: string, text: string) => void;
}

export default function FiTab({
  project,
  metrics,
  sovItems,
  notDrawnItems,
  collapsed,
  statusOptions,
  drawAmount,
  drawPercentage,
  onToggleSov,
  onSetStatus,
  onSetCustomPct,
  onClearCustomPct,
  onToggleFlag,
  onFlagWithComment,
  onAddComment,
}: FiTabProps) {
  return (
    <>
      <div className="commercialBanner">
        <span style={{ fontSize: 20 }}>🏢</span>
        <div className="cbText">
          <strong>Commercial Inspection Mode.</strong> This form shows only the
          SOV line items being drawn on in {project.draw}. Inspect each item
          below and record your field estimate. Items not being drawn are listed
          at the bottom for reference.
        </div>
      </div>

      <div className="drawBanner">
        <div className="drawBannerLeft">
          <span>
            {project.draw} · {project.bank}
          </span>
          {sovItems.length} items being billed
        </div>
        <div className="drawBannerRight">{metrics.avgPct}%</div>
      </div>

      <div className="totalsStrip">
        <div className="totalsTitle">Inspection Progress</div>
        <div className="totalsGrid">
          <div className="totalItem">
            <div className="totalLabel">Items Inspected</div>
            <div className="totalVal blue">
              {metrics.inspectedCount} / {sovItems.length}
            </div>
            <div className="totalSub">This draw</div>
          </div>
          <div className="totalItem">
            <div className="totalLabel">GC Billed (Draw)</div>
            <div className="totalVal amber">{drawAmount}</div>
            <div className="totalSub">
              {drawPercentage ? `${drawPercentage} of contract` : ""}
            </div>
          </div>
          <div className="totalItem">
            <div className="totalLabel">Flags Raised</div>
            <div className="totalVal red">{metrics.flagsCount}</div>
            <div className="totalSub">Line items</div>
          </div>
          <div className="totalItem">
            <div className="totalLabel">Photos</div>
            <div className="totalVal green">{metrics.photosCount}</div>
            <div className="totalSub">Captured</div>
          </div>
        </div>
      </div>

      {sovItems.map((item) => (
        <SovItemSection
          key={item.id}
          item={item}
          collapsed={Boolean(collapsed[item.id])}
          statusOptions={statusOptions}
          onToggle={() => onToggleSov(item.id)}
          onSetStatus={(status) => onSetStatus(item.id, status)}
          onSetCustomPct={(value) => onSetCustomPct(item.id, value)}
          onClearCustomPct={() => onClearCustomPct(item.id)}
          onToggleFlag={() => onToggleFlag(item.id)}
          onFlagWithComment={(text) => onFlagWithComment(item.id, text)}
          onAddComment={(text) => onAddComment(item.id, text)}
        />
      ))}

      {notDrawnItems.length > 0 && (
        <div className="notDrawnSection">
          <div className="ndsTitle">
            SOV Items Not Being Drawn This Period · For Reference Only
          </div>
          {notDrawnItems.map((row) => (
            <div className="ndsItem" key={row[0]}>
              <span className="ndsCode">{row[0]}</span>
              <span className="ndsDesc">{row[1]}</span>
              <span className="ndsStatus">{row[2]}</span>
            </div>
          ))}
        </div>
      )}
    </>
  );
}
